export const SET_OFFICERS = 'set_officers';
export const SET_ISAUTH = 'set_isAuth';
export const SET_ROLE = 'set_role';
export const SET_POSTLOCAION = 'set_postLocation';
export const SET_OFFICERLIST = 'set_officerList';
export const SET_POSTNAME = 'set_postName';